"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const index_1 = require("../index");
const options = [
    { label: 'AM', value: 'AM' },
    { label: 'PM', value: 'PM' },
];
const getValue = (value) => {
    return options.find((option) => option.value === value);
};
const TimePickerPeriodSelect = ({ value, onChange, onFocus, onBlur, }) => (react_1.default.createElement(index_1.Select, { "data-testid": "time-picker-period-select", options: options, onChange: (option) => {
        onChange(option.value);
    }, onFocus: onFocus, onBlur: onBlur, value: getValue(value), disableClearable: true, 
    // Increase min-width without modifying base component
    // Feels cramped for AM/PM options otherwise
    // @ts-ignore
    sx: { minWidth: '100px' } }));
exports.default = TimePickerPeriodSelect;
